export default __webpack_public_path__ + "static/media/logo.ecfb02e2.png";